<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Persona de la sociedad civil que atendió al funcionario o inspector durante la visita
    </h4>
    <form-group :error="errors.has('nombre-atendedor') && submitted">
      <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.nombreAtendedor"
        name="nombre-atendedor"
        required
        v-validate="'required'"
      >
      <label class="form__label">
        7. Nombre de la persona que atendió en la finca
      </label>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('quien-es') && submitted">
        <label class="form__label form__label--required">
          7.1. ¿Quién es él?
        </label>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            name="quien-es"
            id="propietario"
            v-model="form.quienEs"
            value="Propietario"
            v-validate="'required'"
          >
          <label class="form__label" for="propietario">
            Propietario
          </label>
        </div>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            name="quien-es"
            id="encargado"
            v-model="form.quienEs"
            value="Cuidador/encargado/peón"
            v-validate="'required'"
          >
          <label class="form__label" for="encargado">
            Cuidador/encargado/peón
          </label>
        </div>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            name="quien-es"
            id="familiar"
            v-model="form.quienEs"
            value="Familiar del propietario"
            v-validate="'required'"
          >
          <label class="form__label" for="familiar">
            Familiar del propietario
          </label>
        </div>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            name="quien-es"
            id="conocido"
            v-model="form.quienEs"
            value="Un vecino/Conocido del propietario"
            v-validate="'required'"
          >
          <label class="form__label" for="conocido">
            Un vecino/Conocido del propietario
          </label>
        </div>
      </form-group>

      <form-group>
        <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.telefonoAtendedor"
          name="telefono-atendedor"
        >
        <label class="form__label">
          7.2. Teléfono
        </label>
      </form-group>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
};
</script>
